<template>
  <b-container>
    test page
  </b-container>
</template>

<script>
export default {
  name: 'Test',

}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/TestPage.vue